import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { QueryClient, QueryClientProvider, useQuery } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';

import { ShoppingBag } from './ShoppingBag';

const ErrorFallback = () => {
    return (
        <div className="bag__wrapper">
            <div className="bag__details">
                <h2 className="" style={{ fontSize: '14px' }}>
                    Error loading the bag.
                </h2>
                <button className="" onClick={() => window.location.assign(window.location.origin)}>
                    Refresh
                </button>
            </div>
        </div>
    );
};

const ShoppingBagApp = () => {
    const client = new QueryClient({
        defaultOptions: {
            queries: {
                cacheTime: 1000 * 60 * 60 * 24, // 24 hours
                staleTime: Infinity,
            },
        },
    });
    const persister = createSyncStoragePersister({
        storage: window.localStorage,
    });

    return (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <PersistQueryClientProvider client={client} persistOptions={{ persister }}>
                <ReactQueryDevtools initialIsOpen={false} />
                <ShoppingBag />
            </PersistQueryClientProvider>
        </ErrorBoundary>
    );
};

const id = 'shopping-bag';
const element = document.getElementById(id);
const root = ReactDOM.createRoot(element);
if (element) {
    root.render(
        <React.StrictMode>
            <ShoppingBagApp />
        </React.StrictMode>,
    );
}
